import { useTranslation } from 'react-i18next'

import {
  EmailIcon,
  PaymentIcon,
  PhoneIcon,
  SmsIcon,
  TaskCheckIcon,
} from '#/shared/ui/icons'
import { Tooltip } from '#/shared/ui/tooltip'

type TypeCellVariant = 'phone' | 'email' | 'sms' | 'payment' | 'general'

interface TypeCellProps {
  type: TypeCellVariant
}

const iconByType = {
  phone: PhoneIcon,
  email: EmailIcon,
  sms: SmsIcon,
  payment: PaymentIcon,
  general: TaskCheckIcon,
} as const

const labelFallbackByType: Record<TypeCellVariant, string> = {
  phone: 'Phone',
  email: 'Email',
  sms: 'SMS',
  payment: 'Payment',
  general: 'General',
}

export function TypeCell({ type }: TypeCellProps) {
  const { t } = useTranslation()
  const Icon = iconByType[type]
  const label = t(`table.types.${type}`, labelFallbackByType[type])
  return (
    <Tooltip content={label}>
      <div className="flex h-7 items-center justify-center">
        <Icon className="size-4.5 text-gray-500" />
      </div>
    </Tooltip>
  )
}
